module.exports = __webpack_public_path__ + "static/media/ssrikanth-1.83dc8c5f.png";